export function createToolbarEmojiSelectHandler({
  participantLayoutReactionTargetId,
  spawnEmoji,
  emitReaction
} = {}) {
  return emoji => {
    if (participantLayoutReactionTargetId) {
      emitReaction?.({ participantId: participantLayoutReactionTargetId, emoji });
    }

    spawnEmoji?.(emoji);
  };
}
